import { AppButton } from "./AppButton";

export type UpgradePlan = "starter" | "multi";

type Props = {
  plan?: UpgradePlan;
  /** Extra props for layout slots / variants. */
  variant?: string;
  tone?: string;
  slot?: string;
  disabled?: boolean;
};

const MODAL: Record<UpgradePlan, string> = {
  starter: "unlock-starter",
  multi: "unlock-multi",
};

/**
 * Only “Upgrade now” CTA - opens UnlockModals (AppShell).
 * Default primary (Home / Block / Popup Advanced / Store paywall).
 * Use variant="secondary" only when nested inside a banner next to prose.
 * Never invent a second Upgrade button with AppButton to="/app/plans".
 */
export function UpgradeNowButton({
  plan = "starter",
  variant = "primary",
  tone,
  slot,
  disabled,
}: Props) {
  return (
    <AppButton
      variant={variant}
      tone={tone}
      slot={slot}
      icon="key"
      disabled={disabled}
      commandFor={MODAL[plan]}
      command="--show"
    >
      Upgrade now
    </AppButton>
  );
}
